import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, User } from 'firebase/auth';
import { getFirestore, doc, getDoc, setDoc } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAPXHxIeh51WS6JW2dRFBBhDCr2sfiWZWk",
  authDomain: "xpensemate.com",
  projectId: "secondbrain-camera-2024",
  storageBucket: "secondbrain-camera-2024.firebasestorage.app",
  messagingSenderId: "939800704027",
  appId: "1:939800704027:web:c06a25f1c3d63622fbf4be"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const googleProvider = new GoogleAuthProvider();

// ── Role management (userRoles collection) ────────────────────────────────────

export async function getUserRole(uid: string): Promise<string> {
  try {
    const snap = await getDoc(doc(db, 'userRoles', uid));
    return snap.exists() ? (snap.data().role || 'user') : 'user';
  } catch {
    return 'user';
  }
}

export async function ensureUserRole(user: User): Promise<string> {
  const ref = doc(db, 'userRoles', user.uid);
  const snap = await getDoc(ref);
  if (!snap.exists()) {
    await setDoc(ref, {
      email: user.email,
      displayName: user.displayName,
      role: 'user',
      createdAt: Date.now(),
    });
    return 'user';
  }
  return snap.data().role || 'user';
}

export async function promoteToSuperAdmin(uid: string, email: string, displayName: string | null): Promise<void> {
  await setDoc(doc(db, 'userRoles', uid), {
    email,
    displayName,
    role: 'super_admin',
    updatedAt: Date.now(),
  }, { merge: true });
}
